import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { OperationalAssurancesInfoPage } from 'src/app/model/page/group/operational-assurances/operational-assurances-info-page';
import { OperationalAssurancesSection } from 'src/app/model/shared/operational-assurance-section.';
import { TabMenu } from 'src/app/model/shared/tab-menu';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-operational-assurances-info-page',
  templateUrl: './operational-assurances-info-page.component.html',
  styleUrls: ['./operational-assurances-info-page.component.scss']
})
export class OperationalAssurancesInfoPageComponent implements OnInit {
  tabMenu: TabMenu = {} as TabMenu;
  sectionsMap = new Map();
  selectedIndex: number = 0;
  sectionArray: OperationalAssurancesSection[] = [];
  operationalAssurancesInfoPage: OperationalAssurancesInfoPage = {} as OperationalAssurancesInfoPage;
  pageName = 'Operational Assurances Info';

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'oa-info') {
        this.operationalAssurancesInfoPage.htmlTitle = title.htmlTitle;
      }
    });

    const pageQuery = { 'fields.title': this.pageName };
    this.operationalAssurancesInfoPage.sections = [];

    this.contentfulService.getPageContentResponse(pageQuery).then((operationalAssurancesInfoEntries) => {
      this.mapBanner(operationalAssurancesInfoEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.operationalAssurancesInfoPage.banner);
      this.mapPageInfo(operationalAssurancesInfoEntries.items);
      this.mapSections(operationalAssurancesInfoEntries.includes.Entry);
    });
  }

  private mapBanner(ndcoffermanagementcapabilities: Entry<any>[]) {
    ndcoffermanagementcapabilities
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    this.operationalAssurancesInfoPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: ''
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.operationalAssurancesInfoPage.htmlTitle = entry.fields.htmlTitle;
      this.tabMenu.links = entry.fields.constants;
    });
  }

  private mapSections(ndcoffermanagementcapabilities: Entry<any>[]) {
    ndcoffermanagementcapabilities
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });

    this.operationalAssurancesInfoPage.sections.filter((section) => {
      const key = section.group.split('#').pop();
      this.sectionArray = this.sectionsMap.get(key);
      if (this.sectionArray === undefined || this.sectionArray.length === 0) {
        this.sectionArray = [];
      }
      this.sectionArray.push(section);
      this.sectionArray.sort((a, b) => a.order - b.order);
      this.sectionsMap.set(key, this.sectionArray);
    });

    // console.log('sectionmap', this.sectionArray);
  }

  private mapEntryToSection(entry: Entry<any>) {
    this.operationalAssurancesInfoPage.sections.push({
      title: '',
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry.fields['subBody'] as string
    });
  }
}
